const diseasePrevalencePageConstants = {
  DISEASE_PREVALENCE_PAGE: {
    TITLE: 'Disease and Condition Spend',
    PREVALENCE_BY: 'Prevalence by',
    SUBTITLE: {
      PART1:
        'Cost and utilization patterns across diagnoses, conditions, and encounters—highlighting major cost drivers and opportunities for targeted health interventions—using ICD classification from the National Center for Health Statistics (NCHS).',
      PART2: ' to ',
      PART3: ' to plan intervention strategy',
    },
    SUMMARY_CARDS: {
      MEMBERS: 'Cohort Members',
      TOTAL_COST: 'Cohort Cost',
      PMPM: 'Cohort PMPM',
      PEPM: 'Cohort PEPM',
      PC_DISTRIBUTION_MEMBER: 'Primary Care Attribution',
      PC_DISTRIBUTION_COST: 'Primary Care - Cost',
      AVG_AGE: 'Average Age',
      GENDER_TITLE: 'Gender',
    },
    COHORT_DETAILS: {
      TITLE: 'Cohort Details',
      SUBTITLE:
        'Select the properties that you would like to apply to current data',
    },
    PREVALENCE_BY_CONDITION_GRAPH: {
      TITLE: 'No of Conditions by',
      SUB_TITLE_GENDER: 'Showing cost share and number of conditions by gender',
      SUB_TITLE_AGE_GROUP:
        'Showing cost share and number of conditions by age group',
      CATEGORIES: [
        {
          label: '1',
        },
        {
          label: '2',
        },
        {
          label: '3',
        },
        {
          label: '4',
        },
        {
          label: '5+',
        },
      ],
      TOOLTIP:
        'A member with multiple conditions, or comorbidities, can often signal the potential for higher risk.  Here we display the number of conditions members have, broken out by gender or age.',

      CHART_CATEGORIES: [
        {
          category: [
            {
              label: '1 Condition',
            },
            {
              label: '2 Conditions',
            },
            {
              label: '3 Conditions',
            },
            {
              label: '4 Conditions',
            },
            {
              label: '5 Conditions+',
            },
          ],
        },
      ],
    },
    PREVALENCE_CHART: {
      TITLE: 'Prevalence By Condition',
      SUB_TITLE:
        'Showing all the prevalence by conditions by their cost of care percentages',
    },
    NO_DATA_CONTENT: 'No Data Available',
    POLY_DISEASE_PREVALENCE_DISTRIBUTION: {
      TITLE: 'Poly Disease Prevalence Distribution',
      SUB_TITLE: 'Showing cost share and prevalence by comorbidity',
      CATEGORIES: [
        {
          name: 'Good - >90th%',
        },
        {
          name: 'Average - 50th-90th%',
        },
        {
          name: 'Need Intervention - <50th%',
        },
      ],
      LEGENDS: [
        {
          label: '1 Condition',
          color: '#CFDCFF',
        },
        {
          label: '2 Conditions',
          color: '#9CB6FD',
        },
        {
          label: '3 Conditions',
          color: '#AFE9F5',
        },
        {
          label: '4 Conditions',
          color: '#F7D1CD',
        },
        {
          label: '5 Conditions',
          color: '#E8C2CA',
        },
      ],
    },
    MEMBER_HEALTH_DISTRIBUTION: {
      TITLE: 'Member Health Distribution',
      SUB_TITLE: 'Showing distribution between mental and physical conditions',
    },
    SITES_OF_CARE: {
      TITLE: 'Sites of Care',
      SUB_TITLE: 'Showing top sites of care by ',
      DROPDOWN_OPTIONS: ['Member', 'Cost'],
    },
    MEMBER_DISTRIBUTION: {
      TITLE1: 'Member Distribution - Gender',
      TITLE2: 'Member Distribution - Disease Acuity',
      SUBTITLE:
        'Showing distribution of cohort members in different age brackets',
    },
    DISEASE_PREVALENCE: {
      TITLE: 'Top Chronic Prevalence by ',
      SUBTITLE: 'Showing top disease categories by ',
      DROPDOWN_OPTIONS: ['Member', 'Cost'],
    },
    TOP_SPECIALIZATION: {
      TITLE: 'Top Specialization ',
      SUBTITLE: 'Showing top provider specializations by ',
      DROPDOWN_OPTIONS: ['Member', 'Cost'],
    },
    TOP_PROCEDURES: {
      TITLE: 'Top Procedures ',
      SUBTITLE: 'Showing top procedures by ',
      DROPDOWN_OPTIONS: ['Member', 'Cost'],
    },
    TOP_DRUGS_TABLE: {
      TITLE: 'Top Drugs by',
      SUBTITLE:
        'View the drugs in different categories of Medpharma, Specialty and Non-Speciality by clicking on the dropdown',
      DROPDOWN_DISPLAY_VALUES: [
        'All Drugs',
        'Medpharma',
        'Specialty',
        'Non-Speciality',
      ],
      DROPDOWN_VALUES: [
        'All Drugs',
        'Medpharma',
        'Speciality Drug',
        'Non-Speciality Drug',
      ],
    },
    MAIN_SORT_COLUMN: 'totalCost',
    MAIN_SORT_ORDER: -1,
    DRUG_TYPES: {
      MEDPHARMA: 'Medpharma',
      SPECIALITY: 'Speciality Drug',
      OTHER: 'Non-Speciality Drug',
    },
    SOMETHING_WENT_WRONG:
      'Something went wrong. Try again after sometime or Please reachout to support team',
  },
  MEMBER_SUMMARY_CARDS: {
    MEMBER_DETAILS: {
      TITLE: 'Member Details',
      SUB_TITLE: 'To see more about the member details click on a member',
    },
    TOP_DIAGNOSIS: {
      TITLE: 'Top',
      SUB_TITLE: 'Showing All Other Top ',
      DROPDOWN_OPTIONS: ['Diagnosis by Cost', 'Diagnosis by Member'],
    },
    TOP_MEDICATIONS: {
      TITLE: 'Top',
      SUB_TITLE: 'Showing the top ',
      DROPDOWN_OPTIONS: ['Medications by Cost', 'Medications by Member'],
    },
    TOP_PROCEDURES: {
      TITLE: 'Top',
      SUB_TITLE: 'Showing the top ',
      DROPDOWN_OPTIONS: ['Procedures by Cost', 'Procedures by Member'],
    },
    TOP_PROVIDERS: {
      TITLE: 'Top',
      SUB_TITLE: 'Showing the top ',
      DROPDOWN_OPTIONS: ['Providers by Cost', 'Providers by Member'],
    },
  },
};

export default diseasePrevalencePageConstants;
